/* eslint-disable @typescript-eslint/no-var-requires */

// Issue: react-scripts v4.0.0 causes local images to not load
// https://github.com/facebook/create-react-app/issues/9992

export const IMAGES = {
  mapMarker: require('../assets/img/map_marker.svg')?.default,
  mapHome: require('../assets/img/map_home.svg')?.default,
  mapCenterWell: require('../assets/img/centerwell_map_icon.svg')?.default,

  bookVisitOnDemand: require('../assets/img/on_demand.png')?.default,

  applePay: require('../assets/img/applepay.png')?.default,
  googlePay: require('../assets/img/googlepay.png')?.default,

  doctor: require('../assets/img/doctor.png')?.default,
};
